export default {
  roles: [],
  accounts: [],
  errors: null,
  allRolesPermissions: [],
  allPermissions: []
};
